export const storageKeys = {
    TOKEN: "TOKEN",
    USER: "USER",
    FIRSTNAME: "FIRSTNAME",
    LASTNAME: "LASTNAME",
    REFRESH_TOKEN: "REFRESH_TOKEN",
    LANG: "LANG"
}